import React, { useContext } from "react";
import { APIRequestContext } from "../context";
import { authAPI, setAuthToken } from "../lib/apiService";
import { useNavigate, Link } from "react-router-dom";

export default function Login(props) {
  const { request_handler } = useContext(APIRequestContext);
  const navigate = useNavigate();

  const onSubmit = (e) => {
    e.preventDefault();

    const credentials = {
      email: e.target[0].value,
      password: e.target[1].value,
    };
    
    request_handler(async () => {
      const response = await authAPI.login(credentials);
      
      // Set the token in axios defaults and localStorage
      setAuthToken(response.token);
      
      // Store user data if provided
      if (response.user) {
        localStorage.setItem("user", JSON.stringify(response.user));
      }
      
      // Navigate to dashboard
      navigate("/dashboard");
      
      return { data: { message: "Login successful" } };
    });
  };

  return (
    <div className="Auth-form-container">
      <form onSubmit={onSubmit} className="Auth-form">
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Sign In</h3>
          <div className="form-group mt-3">
            <label>Email address</label>
            <input
              type="email"
              className="form-control mt-1"
              placeholder="Enter email"
              required
            />
          </div>
          <div className="form-group mt-3">
            <label>Password</label>
            <input
              type="password"
              className="form-control mt-1"
              placeholder="Enter password"
              required
            />
          </div>
          <div className="d-grid gap-2 mt-3">
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </div>
          <div className="text-center mt-3">
            <p>
              Don't have an account?{" "}
              <Link to="/register" className="link-primary">
                Sign Up
              </Link>
            </p>
          </div>
        </div>
      </form>
    </div>
  );
}
